import moment from '@/moment-gp'
//import { util } from '@google-cloud/common';
//import util from "@/util";

export default {
  create({ itemType }, data) {

    // TODO: suggestionTemplateId

    switch (itemType) {
      case 'SESSION': return {
        type:           "SESSION",
        description:    data.description || '',
        sessionLength:  Number.parseInt(data.sessionLength) || 3600,
        taskSequence:   data.taskSequence ? data.taskSequence.slice() : [
          /* list of create_session_template_item_task() */
        ]
      }

      case 'SESSION:TASK': return {
        type:           "SESSION:TASK",
        goalId:          data.goalId || null,
        memberId:        data.memberId || null,
        taskId:          data.taskId || null,
      }

      case 'PAUSE': return {
        type: 'PAUSE',
        sessionLength: Number.parseInt(data.sessionLength) || 30 * 60,
      }

      case 'NEXT:DAY': return {
        type: 'NEXT:DAY',
        repeat: data.repeat || 1
      }

      case 'NEXT:WEEK': return {
        type: 'NEXT:WEEK',
        repeat: data.repeat || 1
      }

      case 'NEXT:WEEKDAY': return {
        type: 'NEXT:WEEKDAY',
        weekday: data.weekday || 'Mo'
      }

      case 'NEXT:DATE': return {
        type: 'NEXT:DATE',
        // TODO: Check for timezone bugs
        // date: (new Date(data.date)).getTime() / 1000 || null
        date: moment.isValidDate( data.date ) ? data.date.toRealtimeDB() : null,
      }
    }
  },

  create_session_template_item_task(data) {
    return {
      description:  data.description || '',
      duration:     Number.parseInt(data.duration) || 10 * 60
    }
  },

  fields: {
    type: {},
    description: {},
    taskSequence: {},
    sessionLength: {},
    repeat: {},
    weekday: {},
    date: { validate_bolt_type: 'Timestamp' },
    icon: { validate_bolt_type: 'Object' }, // TODO
    goalId: { validate_bolt_type: 'AnyID' },
    memberId: { validate_bolt_type: 'AnyID' },
    taskId: { validate_bolt_type: 'AnyID' },
  }
};
